import React, { useContext } from 'react'
import { StoreContext } from '../contexts/StoreProvider';
import Loader from './Loader';

const LoaderContainer = ({children}) => {
  const [state, dispatch] = useContext(StoreContext);

  return (
    <>
      {children}
      {state.loader.visible ? <Loader/> : <></>}
    </>
  );
}

export default LoaderContainer 